import { Stack } from "@mui/material";
import BMIScreen from ".";
import type { BMIChartDataPoint } from "../BMIChart";

const sampleChartData: BMIChartDataPoint[] = [
  { date: "20/01", bmi: 24.5, fullDate: "20.01.2025" },
  { date: "02/04", bmi: 28, fullDate: "02.04.2025" },
  { date: "04/04", bmi: 30.2, fullDate: "04.04.2025" },
  { date: "12/05", bmi: 31.5, fullDate: "12.05.2025" },
  {
    date: "20/08",
    bmi: 31.22,
    fullDate: "20.08.2025",
    isSelected: true,
  },
];

export default function BMIScreenExamples() {
  return (
    <Stack gap={4} width="100%">
      <BMIScreen
        chartData={sampleChartData}
        weightKg={84}
        heightCm={165}
        lastUpdated="2025-02-23T00:00:00Z"
      />
    </Stack>
  );
}
